<template>
  <div id="bottom">
    <div class="clearfix"/>
    <div class="menu">
      <el-card
        class="box-card"
        shadow="never"
        v-if="!dentalOnly"
        v-for="region in ['apac','emea','americas']"
        :key="region"
      >
        <div slot="header" class="clearfix">
        <!--
	  <span>{{ $t("cmsg."+region+".title") }}</span>
        -->
	</div>
        <div>
        <!--
	  <p>{{ $t("cmsg."+region+".company") }}</p>
          <p>{{ $t("cmsg."+region+".tel") }}</p>
          <p>{{ $t("cmsg."+region+".addr") }}</p>
        -->
	</div>
      </el-card>
      <el-card class="box-card" shadow="never" v-if="!dentalOnly">
        <div slot="header" class="clearfix">
        <!--
	  <span>{{ $t("cmsg.support_email") }}</span>
        -->
	</div>
        <div>
          <p>
          </p>
        </div>
      </el-card>
      <hr>
      {{ $t("cmsg.copyright") }}{{$gf.sysParam($gf.lang(), "copyright")}}
      <el-button type="text" @click="privacyVisible = true" class="btn_privacy" v-if="$gf.lang() === 'en'">Privacy Policy</el-button>
      <el-dialog
  title="Privacy Policy"
  :visible.sync="privacyVisible"
  :close-on-click-modal="false"
  :close-on-press-escape="false"
  width="80%">
  <privacyEnLib/>
</el-dialog>
      <br>
      {{$t('cmsg.browserSupport')}}
    </div>
  </div>
</template>

<script>
import privacyEnLib from "./privacyEn.vue";
export default {
  name: "bottom",
  components: {
    privacyEnLib
  },
  data() {
    return {
      privacyVisible: false,
      dentalOnly: false
    };
  },
  methods: {},
  mounted() {

    console.log("mounted:",pub.dentalOnly);
    if(pub && pub.dentalOnly) {
      this.dentalOnly = pub.dentalOnly;
    }
  }
};
</script>
<style lang="scss">
#bottom {
  padding-bottom: 25px;
  background-color: #ffffff;
  .menu {
    // min-width: 1200px;
    width: 65vw;
    @media only screen and (max-width: 1020px) {
      width: 95vw;
    }
    margin: 0 auto;
    text-align: left;
    .el-card.box-card {
      width: 31vw;
      @media only screen and (max-width: 1020px) {
        width: 95vw;
      }
      display: inline-table;
      margin-right: 15px;
      border-width: 0px;
      .el-card__header {
        background-color: transparent;
        .clearfix {
          span {
            font-size: 20px;
            font-weight: 700;
            color: #4b91d1;
            // margin-bottom:10px;
          }
        }
        padding: 10px 0px;
      }
      .el-card__body {
        padding: 10px 0px;
      }
    }
    hr {
      color: #4b91d1;
      background-color: #4b91d1;
      height: 1px;
      border-width: 0px;
    }
  }
}
</style>
